import React from 'react'
import classNames from 'classnames'

import { Button } from 'components/base'
import { PlusIcon } from 'components/Utils/Icons'

export type NewNoteButtonLayoutProps = {
  className?: string
  onClick: () => void
  label: React.ReactNode
  disabled?: boolean
}

export function NewNoteButtonLayout({
  className,
  onClick,
  label,
  disabled,
}: NewNoteButtonLayoutProps) {
  return (
    <Button.Primary
      disabled={disabled}
      onClick={onClick}
      style={{ padding: '0 12px', height: 36 }}
      className={classNames(
        'child-effects-on-hover',
        'pointer flexbox width-full transition flexbox-justify-start margin-bottom-small margin-top-smaller',
        className
      )}
    >
      <PlusIcon size={12} className="flexbox-no-shrink" />
      <div
        style={{ alignItems: 'baseline', width: '95%' }}
        className="font-size-large line-height-larger margin-left-small flexbox font-weight-bold"
      >
        {label}
      </div>
    </Button.Primary>
  )
}
